import $ from 'jquery';
import slick from 'slick-carousel';
import slick from 'slick-lightbox';


export default (selector) => {

    // var slider = $(selector);
    $(selector).slick();

    $('.component-slider-room-sport-visual').slick({
        slidesToShow: $('.card-slider-pill').length,
        asNavFor: ".component-slider-rooms-visual",
        focusOnSelect: true,
        centerMode: true
    });

    if($('.single-room-slider').length > 0) {
        $('.single-room-slider .slider').slickLightbox({
            src: 'src',
            itemSelector: 'div img'
        });
    }
};



// WEBPACK FOOTER //
// ./scripts/libs/slick.js